import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const HeroSection = () => {
  return (
    <Box sx={{ mb: { xs: 3, md: 6 } }}>
      <Typography variant="h1" component="h1" gutterBottom >
        Faire un don<br /> et soutenir la mission
      </Typography>
      <Typography variant="body1" sx={{ mb: { xs: 2, md: 4 }, maxWidth: '600px' }}>
        Soutenez notre mission et nos actions humanitaires
      </Typography>
      <Button
        variant="contained"
        href='/donate'
        sx={{
          px: { xs: 2, md: 4 }, // Ajoute de l'espace horizontal autour du texte
          py: { xs: 0.75, md: 1.5 }, // Ajoute de l'espace vertical autour du texte
        }}
      >
        Faire un don
      </Button>
    </Box>
  );
};

export default HeroSection;